import SignIn from './components/root/signin';
import SignOut from './components/root/signout';
import SingleSignOn from './components/root/sso';
import ForgotPassword from './components/forgot-password';
import ForgotPasswordHeader from './components/forgot-password-header';
import ForgotPasswordSuccess from './components/forgot-password-success';
import ResetPassword from './components/reset-password';
import ResetPasswordHeader from './components/reset-password/header';
import ResetPasswordSuccess from './components/reset-password/success';
import ValidatePasswordResetHeader from './components/validate-password-reset/header';
import ValidatePasswordReset from './components/validate-password-reset';
import { SIGNAL_SIGN_IN } from './actions';
import reducer from './state/root-reducer';
import { middlewareClientMapping } from 'shared/app/utils/middleware-mapping';

const { clearAllAuthCookies, validateReturnUrl, validateForgotPasswordReset } =
  middlewareClientMapping;

export default {
  name: 'accountSignin',
  reducer,
  routes: {
    '/account/signin': {
      fullPageComponent: SignIn,
      applyMiddleware: [clearAllAuthCookies, validateReturnUrl],
      nav: {
        globalNav: {
          props: {
            logoOnly: true,
          },
        },
      },
    },
    '/account/signin/sso/:token': {
      fullPageComponent: SingleSignOn,
      applyMiddleware: [validateReturnUrl],
    },
    '/account/signout': {
      fullPageComponent: SignOut,
      applyMiddleware: [clearAllAuthCookies, validateReturnUrl],
    },
    '/account/forgot-password': {
      headerCrate: ForgotPasswordHeader,
      contentCrate: ForgotPassword,
      hideGlobalNav: true,
    },
    '/account/forgot-password/success': {
      headerCrate: ForgotPasswordHeader,
      contentCrate: ForgotPasswordSuccess,
      hideGlobalNav: true,
    },
    '/account/reset-password-success': {
      headerCrate: ResetPasswordHeader,
      contentCrate: ResetPasswordSuccess,
      hideGlobalNav: true,
    },
    '/account/reset-password/:token': {
      headerCrate: ResetPasswordHeader,
      contentCrate: ResetPassword,
      hideGlobalNav: true,
    },
    '/account/forgot-password-reset/:token': {
      headerCrate: ValidatePasswordResetHeader,
      contentCrate: ValidatePasswordReset,
      hideGlobalNav: true,
      applyMiddleware: [validateForgotPasswordReset],
    },
  },
  asyncActions: [SIGNAL_SIGN_IN],
};
